
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewVoD from './viewVoD';
import viewRelatedVods from './viewRelatedVods';

export default {
  attributeName: 'composeExperienceMulticams',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  
  emptyMessage: "Can't find files for this composed experience.",
  fields: [
    {
      attributeName: 'url',
      label: 'url',
      type: FormInputTypes.TEXT_OR_RELATIONSHIP,
      helpText: 'Files.',
      popupSize:'xl',
      configFile: viewRelatedVods,
      default: '',
      
      canEdit: false,
      canCreate: false,
      canRemove: false,
      rowKeys: {
        mainKey: 'name',
        foreignKey: 'vodId',
        foreignKeyName: 'VoD',
        valueToShow: 'name',
      },
    },
    
  ],
};
